import { fade, show, select, highlight, videoPanel, newsContent, devNotice, rotateFull, enabled, gameFeature } from '../../app.animations';
import { Input, OnInit, Injectable, Inject, HostListener, Component, ViewChild,ElementRef } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http, Response, Headers } from '@angular/http';

/**
* Declare JQuery
**/

declare var $: any
declare var MasterSlider: any
declare var MSSliderEvent: any


@Component({
  selector: 'home-features',
  templateUrl: './feature.component.html',
  animations: [fade, show, select, highlight, videoPanel, newsContent, devNotice, rotateFull, enabled, gameFeature]
})
export class HomeFeatureComponent implements OnInit {


	@ViewChild('Box1') Box1;
	@ViewChild('Box2') Box2;
	@ViewChild('Box3') Box3;
	@ViewChild('Box4') Box4;

	@ViewChild('copvideo') copvideo: any;
	@ViewChild('shopvideo') shopvideo: any;
	@ViewChild('apartmentvideo') apartmentvideo: any;

	// Status buttons for page items
	b = 0; // buttons

	// Line from buttons to slider
	topLeft: any; // pixels left
	bottomLeft: any; // pixels left
	bottomWidth: any; // pixels left
	loaderWidth: any;
	titleCard: any;
	headerHeight: any;
	subtitle: any;

	// background position
	bgX = 0;
	bgY = 0;
	bgPos = '';

	// button showcase
	selectedButton: number;
	titlePanel = false;
	bottomSignup = false;
	buttonsOnScreen = 4;
	buttons = [1,2,3,4];

	// App construct
	constructor(private http : Http,
				private elementRef: ElementRef) { 
		this.loaderWidth = '100%';
	}


	/* Mouse Movements */
	@HostListener('mousemove', ['$event'])
    onMousemove(event: MouseEvent) {
		this.bgX   = -(event.clientX/10);
		this.bgY   = -(event.clientY/10);
		this.bgPos = this.bgX+'px '+this.bgY+'px';
    }
	


	selectButton(e,i=0) {
		if ( e.path[i].offsetLeft > 0 ) {
			this.topLeft = e.path[i].offsetLeft + e.path[i].offsetWidth/2 + 'px';

			if ( this.selectedButton > 2 ) {
				this.bottomLeft = '50%';
				this.bottomWidth = (window.innerWidth/2)-(e.path[i].offsetLeft + e.path[i].offsetWidth/2)+'px';
			} else {
				this.bottomLeft = e.path[i].offsetLeft + e.path[i].offsetWidth/2 + 'px';
				this.bottomWidth = (window.innerWidth/2)-(e.path[i].offsetLeft + e.path[i].offsetWidth/2)+'px';
			}

		} else { 
			i = i+1;
			this.selectButton(e,i);
		}
	}



	sizeButtons() {
		this.buttonsOnScreen = 4;
		let width = window.innerWidth;
		if (width < 768) {
			this.buttonsOnScreen = 1;
		} else if (width < 980) {
			this.b = 0;
			this.buttonsOnScreen = 2;
		} else if (width < 1200) {
			this.b = 0;
			this.buttonsOnScreen = 2;
		} 
	}

	private adjustVideo() {
		// Width adjustment
		let width = window.innerWidth;
		let videoplayer = window.document.getElementById('Video');
		if (videoplayer) {
			let rightPush = (videoplayer.clientWidth - width) / 2;
			videoplayer.style.left = '-'+rightPush+'px';	
		}

	}

	ngOnInit() {

		/**
		 * Title Card 
		**/

		// this.titleCard = $( '.uc-container' ).pfold({
			// folds : 3,
			// easing : 'ease-in-out',
			// folddirection : ['left','bottom','right']
		// });

		// setTimeout( () => { this.titleCard.unfold(); }, 2000);


		setTimeout( () => {
			this.sizeButtons();
			$('#ShareID').socialShare({ social: 'blogger,delicious,digg,facebook,google,linkedin,myspace,reddit,stumbleupon,tumblr,twitter' });
		}, 200);


		window.addEventListener("resize", () => {
		    this.sizeButtons();
		}, false);


		this.headerHeight = '0px';
		this.subtitle = '';


		setTimeout( () => {
			this.adjustVideo();
		}, 200);
	
		window.addEventListener("orientationchange", () => {
		    this.adjustVideo();
		}, false);

		window.addEventListener("resize", () => {
		    this.adjustVideo();
		}, false);


		/**
		 * Product Sliders 
		**/

		var slider = new MasterSlider();

		slider.setup('featureSlider', {
			instantStartLayers: false,
			autoheight: true,
			autoplay: true,
			keyboard: true,
			fullwidth:true,
			view:"fade",
			height: 1000,
			loop: true,
			speed: 100,
			filters: {
				grayscale: 1,
				opacity: 0.5,
				brightness: 2
       		}
		});

		slider.control('arrows');
		slider.control('bullets' , {autohide:false  , dir:"v", align:"bottom"});

		// slider.api.addEventListener(MSSliderEvent.CHANGE_START, function (e) {
		// 	if( e.target.currentSlide.index == 0 ) this.copvideo.nativeElement.play();
		// 	if( e.target.currentSlide.index == 1 ) this.shopvideo.nativeElement.play();
		// 	if( e.target.currentSlide.index == 2 ) this.apartmentvideo.nativeElement.play();
		// });

	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/home/features/feature.component.ts